export default "__VITE_ASSET__ed501da4__"